/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $InsiderStatsSchema = {
    properties: {
        goals: {
            type: 'number',
            isRequired: true,
        },
        cards: {
            type: 'number',
            isRequired: true,
        },
        chances: {
            type: 'number',
            isRequired: true,
        },
        changes: {
            type: 'number',
            isRequired: true,
        },
        lineups: {
            type: 'number',
            isRequired: true,
        },
        matchViews: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
